@if (contentVersions && contentVersions.length > 0) {
  <div class="container">
    <div class="divider"></div>
    <div class="frame-165">
        <div class="frame-64">
          <img class="clipboard-text" src="../../assets/clipboard-text.png" />
        </div>
      <div class="introduction">History of changes</div>
    </div>

    <div class="content-row">
      @for (version of contentVersions; track version.key) {
          <div class="item">
            <div class="content-version-item-header">
              <button class="version-button" (click)="selectVersion(version)">
                <img src="../../assets/revert-version.png" class="version-button-icon"/>
              </button>
              {{version.dateOfUpdate | date:'dd.MM.yyyy HH:mm:ss'}} 
              {{version.authorName}}
            </div>
                  <div class="card-body">
                  <p class="card-text" [innerHTML]="version.nameHTML || version.name">
                  </p>
                </div>
            </div>
        }
    </div>
</div>
}
